import { getLabelByValue, renderNullable } from "@/utils";

export default {
  install(app) {
    const globalFns = {
      renderNullable,
      getLabelByValue,
    };
    Object.entries(globalFns).forEach(([key, fn]) => {
      app.config.globalProperties[key] = fn;
    });
  },
};
